// extracted by mini-css-extract-plugin
var _1 = "UserSquarishCard-module__animateUploadProgressBarWidth--rYbGU";
var _2 = "UserSquarishCard-module__animatedBackground--AmV7Z";
var _3 = "UserSquarishCard-module__avatar--HsVL0";
var _4 = "UserSquarishCard-module__badge--e4ane";
var _5 = "UserSquarishCard-module__banner--XUEVb";
var _6 = "UserSquarishCard-module__color1--cUTVR";
var _7 = "UserSquarishCard-module__color2--UbCMC";
var _8 = "UserSquarishCard-module__color3--qb8VE";
var _9 = "UserSquarishCard-module__color4--XvklE";
var _a = "UserSquarishCard-module__color5--yShug";
var _b = "UserSquarishCard-module__color6--LjJrs";
var _c = "UserSquarishCard-module__footerIcon--d0FA7";
var _d = "UserSquarishCard-module__oneLine--u9Upl";
var _e = "UserSquarishCard-module__twoLines--tMxgD";
var _f = "UserSquarishCard-module__userInfo--q2bj1";
var _10 = "UserSquarishCard-module__userName--Ait1q";
var _11 = "UserSquarishCard-module__userTitle--RE557";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "avatar", _4 as "badge", _5 as "banner", _6 as "color1", _7 as "color2", _8 as "color3", _9 as "color4", _a as "color5", _b as "color6", _c as "footerIcon", _d as "oneLine", _e as "twoLines", _f as "userInfo", _10 as "userName", _11 as "userTitle" }
